import axios from "axios";
import { ExperiencesAvailabilityAutocompleteRequest } from "redmond";
import { config } from "../../config";
import { experiencesAvailabilityAutocompleteApiPrefix } from "../paths";

export const fetchExperiencesAvailabilityAutocomplete = async (
  body: ExperiencesAvailabilityAutocompleteRequest
): Promise<ExperiencesAvailabilityAutocompleteRequest> => {
  const res = await axios.post(
    experiencesAvailabilityAutocompleteApiPrefix,
    body,
    {
      baseURL: config.baseURL,
    }
  );

  return res.data.value;
};
